import { render, staticRenderFns } from "./AppPromocodes.vue?vue&type=template&id=55125e7e&scoped=true&"
import script from "./AppPromocodes.vue?vue&type=script&lang=js&"
export * from "./AppPromocodes.vue?vue&type=script&lang=js&"
import style0 from "./AppPromocodes.vue?vue&type=style&index=0&id=55125e7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55125e7e",
  null
  
)

export default component.exports